var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    className: "ng-tns-c2123674418-2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85,50.2c0,1.6,0,3.3-.3,4.8-1,5.3-6,8.7-11.3,7.9-.5,0-.8,0-1.1.5-4.2,6-10,9.8-17.2,11.3-.5,0-.8.3-1,.8-1.2,2.5-4,3.9-6.7,3.2-2.7-.7-4.6-3.1-4.5-5.9,0-2.8,2.1-5.2,4.9-5.6,2.4-.4,4.8.7,6,2.8.3.5.6.6,1.1.4,9.4-2.1,16.4-9.7,17.7-19.3,1.6-12-6.7-23.3-18.5-25.4-12.3-2.1-23.8,5.5-26.4,17.7-1.2,5.4-.4,10.5,2.1,15.4,1,1.9.5,3.1-1.5,3.7-6.3,2.1-12.9-2.4-13.2-9.1,0-2.5-.1-5,.1-7.5.4-4.5,4.5-8.2,9-8.5.7,0,1-.3,1.3-.9,5.3-10.2,13.8-15.7,25.3-15.3,10.8.3,18.6,5.9,23.5,15.5.3.5.5.7,1,.7,5.2.3,9.3,4.6,9.4,9.9,0,1,0,2,0,3,0,0,0,0,0,0Z",
    fill: "#079D49",
    className: "cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50,32.9c8,0,14.7,6.2,15.4,14.1.7,8.5-5.4,15.8-13.8,16.8-1.7.2-3.4,0-5.1-.3-.3,0-.7,0-1,.1,0,0-4.2,1.7-6.1,2.8-1.3.7-2,0-2-.8,0-.3,0-.7.1-1,.4-1.7.9-5.2.9-5.2,0-.3,0-.6-.2-.9-3.8-4.7-4.9-9.9-2.8-15.6,2.2-5.7,6.5-9,12.6-9.9.4,0,.8,0,1.2,0,.2,0,.4,0,.7,0Z",
    fill: "#079D49",
    className: "cls-1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50,50.3c-1.2,0-2.1-.9-2.1-2.1,0-1.1.9-2.1,2.1-2.1,1.2,0,2.1,1,2.1,2.1,0,1.2-.9,2.1-2.1,2.1Z",
    fill: "#ffffff",
    className: "cls-2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9,50.2c-1.2,0-2.1-.9-2.1-2.1,0-1.2,1-2.2,2.1-2.1,1.1,0,2.1,1,2.1,2.1,0,1.2-.9,2.1-2.1,2.1Z",
    fill: "#ffffff",
    className: "cls-2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57,50.2c-1.2,0-2.1-.9-2.1-2.1,0-1.1,1-2.1,2.1-2.1,1.2,0,2.1,1,2.1,2.2,0,1.2-1,2.1-2.1,2Z",
    fill: "#ffffff",
    className: "cls-2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactActive);
export default __webpack_public_path__ + "static/media/contact-active.3c49080dc2dfcb052e123f6b53df1c0f.svg";
export { ForwardRef as ReactComponent };